/**
 * @component Footer
 * @description 회사 기본 정보와 연락처를 고정 노출해 신뢰성과 접근성을 높이는 전역 푸터 컴포넌트입니다.
 * @usage MainLayout 하단에 배치되어 모든 페이지에서 공통으로 렌더링됩니다.
 */

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <div>
          <strong>(주)새힘정보기술</strong>
          <p>제약·화장품 산업 특화 솔루션 파트너</p>
        </div>

        <div className="footer-meta">
          <p>충북 청주시 흥덕구 봉명로 31 티원타워 1216호</p>
          <p>TEL. 043-217-9953 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; FAX. 043-215-9954</p>
          <p>© 2026 SAEHIM Information Technology. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
